import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-check-label mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-2 card p-2"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p><span class=\"shimmer-loading block-size-4\"></span></p><p><i class=\"fas fa-address-book\"></i><span class=\"shimmer-loading block-size-8\"></span></p><p><i class=\"fas fa-mobile-alt\"></i><span class=\"shimmer-loading block-size-6\"></span></p><p><i class=\"fas fa-at\"></i><span class=\"shimmer-loading block-size-4\"></span></p>", 4)
const _hoisted_9 = [
  _hoisted_5
]
const _hoisted_10 = {
  key: 1,
  class: "d-flex flex-column mt-2 card p-2"
}
const _hoisted_11 = {
  key: 0,
  class: "font-size-base fw-bold"
}
const _hoisted_12 = {
  key: 1,
  class: "mb-1 text-secondary d-flex"
}
const _hoisted_13 = {
  key: 0,
  class: "badge badge-outline-success"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle me-1" }, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" PECOS ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "badge badge-outline-danger"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle me-1" }, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" PECOS ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Contact Information:", -1 /* HOISTED */)
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "me-1" }
const _hoisted_24 = {
  key: 0,
  class: "me-1"
}
const _hoisted_25 = { class: "me-1" }
const _hoisted_26 = { class: "me-1" }
const _hoisted_27 = { class: "me-1" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "Phone:", -1 /* HOISTED */)
const _hoisted_30 = {
  key: 1,
  class: "text-default"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "Fax:", -1 /* HOISTED */)
const _hoisted_32 = {
  key: 1,
  class: "text-default"
}
const _hoisted_33 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormatName = _resolveComponent("FormatName")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1 /* TEXT */),
      (_ctx.isHospiceLos)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_TypeaheadInput, {
        getData: _ctx.getPhysicianList,
        onValueChanged: _ctx.physicianChanged,
        value: _ctx.physician,
        placeholder: "Start Typing...",
        characterLimit: 3,
        disabled: _ctx.disabled,
        onBlurredInput: _ctx.emitBlur
      }, null, 8 /* PROPS */, ["getData", "onValueChanged", "value", "disabled", "onBlurredInput"]),
      (_ctx.loadingPhyDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_9))
        : _createCommentVNode("v-if", true),
      (!_ctx.loadingPhyDetails && _ctx.hasData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.physicianDetails.lastName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createVNode(_component_FormatName, {
                    lastName: _ctx.physicianDetails.lastName,
                    firstName: _ctx.physicianDetails.firstName
                  }, null, 8 /* PROPS */, ["lastName", "firstName"])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.physicianDetails.npiNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(" NPI: " + _toDisplayString(_ctx.physicianDetails.npiNumber) + " ", 1 /* TEXT */),
                  (_ctx.physicianDetails.isPecosVerified)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_16))
                    : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_20)), [
                        [_directive_tooltip, { title: _ctx.physicianDetails.pecosBadgeToolTip }]
                      ])
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.physicianDetails.address.addressLine1) + ",", 1 /* TEXT */),
              (_ctx.physicianDetails.address.addressLine2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.physicianDetails.address.addressLine2) + ", ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.physicianDetails.address.city) + ",", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.physicianDetails.address.state), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatZipCode(_ctx.physicianDetails.address.zipCode)), 1 /* TEXT */)
            ]),
            (_ctx.physicianDetails.phoneNumbers.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  _hoisted_29,
                  (!!_ctx.primaryPhoneNumber.number)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(_ctx.primaryPhoneNumber.number)) + " ", 1 /* TEXT */),
                        (!!_ctx.primaryPhoneNumber.extension)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Extn: " + _toDisplayString(_ctx.primaryPhoneNumber.extension), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("i", _hoisted_30, "Not Available")),
                  (_ctx.alternatePhoneNumber && _ctx.alternatePhoneNumber.number)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" , " + _toDisplayString(_ctx.formatPhoneNumber(_ctx.alternatePhoneNumber.number)) + " ", 1 /* TEXT */),
                        (!!_ctx.alternatePhoneNumber.extension)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Extn: " + _toDisplayString(_ctx.alternatePhoneNumber.extension), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", null, [
              _hoisted_31,
              (!!_ctx.physicianDetails.faxNumber)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(_ctx.physicianDetails.faxNumber)), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("i", _hoisted_32, "Not Available"))
            ]),
            (_ctx.physicianDetails.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.physicianDetails.email), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}